import { z } from 'zod';
import { Clock } from 'lucide-react';
import { ListTile } from '../list-tile';
import { drilldowns } from '../../drilldowns';
import { useDashboardMetric } from '@/hooks/use-dashboard-metric';
import type { TileDefinition } from './types';

export const openTasksByAgeTile: TileDefinition = {
  type: 'open_tasks_by_age',
  title: 'Open task age',
  description: 'Open tasks bucketed by how long they have been open.',
  icon: Clock,
  metrics: ['open_tasks_by_age'],
  defaultSize: { w: 6, h: 4 },
  minSize: { w: 3, h: 3 },
  configSchema: z.object({}).strict(),
  defaultConfig: {},
  render: ({ period, dashboardCtx, enabled }) => {
    const { metric, isLoading, isError } = useDashboardMetric({
      metricKey: 'open_tasks_by_age',
      from: period.from,
      to: period.to,
      enabled,
    });
    const items = metric?.items ?? [];
    return (
      <ListTile
        rows={items.map((b) => ({
          id: b.label,
          label: b.label,
          value: b.count,
          // Buckets at or beyond 3 days are flagged as stale —
          // matches the manager mental model that anything older
          // than ~3 days is overdue for a touch.
          tone: b.minDays >= 3 ? 'warning' : 'default',
          drilldown: drilldowns.openTasksByAge(b, dashboardCtx),
        }))}
        isLoading={isLoading}
        isError={isError}
        emptyMessage="No open tasks"
      />
    );
  },
};
